"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultIs = exports.withResult = void 0;
exports.err = err;
exports.ok = ok;
var with_result_1 = require("./with-result");
Object.defineProperty(exports, "withResult", { enumerable: true, get: function () { return with_result_1.withResult; } });
function err(error) {
    return {
        data: null,
        error: error,
        successOrThrow() {
            throw error;
        },
        successOrDefault(defaultValue) {
            return defaultValue;
        },
        transformOnFailure(fn) {
            return err(fn(error));
        },
        transformOnSuccess() {
            return this;
        }
    };
}
function ok(data = undefined) {
    return {
        data: data,
        error: null,
        successOrThrow() {
            return data;
        },
        successOrDefault() {
            return data;
        },
        transformOnFailure() {
            return this;
        },
        transformOnSuccess(fn) {
            return ok(fn(data));
        }
    };
}
exports.ResultIs = {
    success: ok,
    failure: err
};
